import { FETCH_GET, FETCH_POST } from "../../config";
import { push } from "react-router-redux";
import { emptyCart } from "./cart";
import activeDiscount from "../../helpers/activeDiscount";
import calculatePrice from "../../helpers/calculatePrice";

export const CREATE_ORDER_PENDING = "CREATE_ORDER_PENDING";
export const CREATE_ORDER_FULFILLED = "CREATE_ORDER_FULFILLED";
export const CREATE_ORDER_REJECTED = "CREATE_ORDER_REJECTED";

export const FETCH_ORDERS_PENDING = "FETCH_ORDERS_PENDING";
export const FETCH_ORDERS_FULFILLED = "FETCH_ORDERS_FULFILLED";
export const FETCH_ORDERS_REJECTED = "FETCH_ORDERS_REJECTED";

export const GET_ORDER_PENDING = "GET_ORDER_PENDING";
export const GET_ORDER_FULFILLED = "GET_ORDER_FULFILLED";
export const GET_ORDER_REJECTED = "GET_ORDER_REJECTED";

export const GET_ORDER_ENQUIRY_PENDING = "GET_ORDER_ENQUIRY_PENDING";
export const GET_ORDER_ENQUIRY_FULFILLED = "GET_ORDER_ENQUIRY_FULFILLED";
export const GET_ORDER_ENQUIRY_REJECTED = "GET_ORDER_ENQUIRY_REJECTED";

export const orderEnquiry = (id) => {
  const query = `query={orderEnquiry(id:"${id}"){
    id
    c_number
    payment
    address
    comment
    customer {
      id
      addresses {
        id
        address_name
        full_name
        city
        town
        postal_code
        address
        phone
        active
      }
    }
    shipping_cost
    total_price
    products {
      quantity
      price
      product {
        id
        name
        image
        sale_price
        price
        slug
        categories {
          id
          discount {
            percent
            price
          }
        }
      }
    }
    created_at
    status
    history {
      comment
      status
      created_at
    }
  }}`;
  return async (dispatch) => {
    dispatch({ type: GET_ORDER_ENQUIRY_PENDING });
    try {
      const result = await FETCH_GET(query);
      console.log("result:", result);
      if (result.data.errors) {
        dispatch({
          type: GET_ORDER_ENQUIRY_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: GET_ORDER_ENQUIRY_FULFILLED,
          payload: result.data.data.orderEnquiry,
        });
        // dispatch(push("/"));
      }
    } catch (e) {
      dispatch({
        type: GET_ORDER_ENQUIRY_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

export const getOrder = (id) => {
  const query = `query={getOrder(id:"${id}"){
    id
    c_number
    payment
    address
    comment
    customer {
      id
      addresses {
        id
        address_name
        full_name
        city
        town
        postal_code
        address
        phone
        active
      }
    }
    shipping_cost
    total_price
    products {
      quantity
      price
      product {
        id
        name
        image
        sale_price
        price
        slug
        categories {
          id
          discount {
            percent
            price
          }
        }
      }
    }
    created_at
    status
    history {
      comment
      status
      created_at
    }
  }}`;
  return async (dispatch) => {
    dispatch({ type: GET_ORDER_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_GET(query, token);
        if (result.data.errors) {
          dispatch({
            type: GET_ORDER_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: GET_ORDER_FULFILLED,
            payload: result.data.data.getOrder,
          });
          // dispatch(push("/"));
        }
      } catch (e) {
        dispatch({
          type: GET_ORDER_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const fetchOrders = () => {
  const query = `query={fetchOrders{id,c_number,shipping_cost,total_price,products{product{id}},created_at,status}}`;
  return async (dispatch) => {
    dispatch({ type: FETCH_ORDERS_PENDING });
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const result = await FETCH_GET(query, token);

        if (result.data.errors) {
          dispatch({
            type: FETCH_ORDERS_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: FETCH_ORDERS_FULFILLED,
            payload: result.data.data.fetchOrders,
          });
          // dispatch(push("/"));
        }
      } catch (e) {
        dispatch({
          type: FETCH_ORDERS_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const createNewOrderForGuest = ({
  payment,
  products,
  comment,
  ///////////
  setting,
  email,
  full_name,
  city,
  town,
  postal_code,
  address,
  phone,
}) => {
  const cartTotalDiscountPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((product) =>
              parseFloat(
                calculatePrice(product, activeDiscount(product.categories))
              )
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const cartTotalPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((item) =>
              item.sale_price
                ? item.quantity * item.sale_price
                : item.quantity * item.price
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const discount = parseFloat(cartTotalPrice - cartTotalDiscountPrice).toFixed(
    2
  );

  const query = `mutation($input:createOrderForGuestInput){createNewOrderForGuest(input:$input){id,shipping_cost,total_price,discount,payment,c_number}}`;
  const variables = JSON.stringify({
    input: {
      email,
      status: "Onay Bekliyor",
      address: {
        full_name,
        city,
        town,
        postal_code,
        address,
        phone,
      },
      history: {
        status: "Onay Bekliyor",
        comment: "",
        notification: false,
      },
      products: products.map((item) => ({
        product: item.id,
        quantity: item.quantity,
        price: item.sale_price
          ? parseFloat((item.sale_price * item.quantity).toFixed(2))
          : parseFloat((item.price * item.quantity).toFixed(2)),
      })),
      comment,
      payment,
      shipping_cost: parseFloat(
        setting.free_shipping >= cartTotalPrice ? setting.shipping_cost : 0
      ),

      total_price:
        setting.free_shipping >= cartTotalDiscountPrice
          ? cartTotalDiscountPrice + setting.shipping_cost
          : cartTotalDiscountPrice,
      discount,

      // total_price: parseFloat(
      //   products
      //     .map((item) =>
      //       item.sale_price
      //         ? parseFloat((item.sale_price * item.quantity).toFixed(2))
      //         : parseFloat((item.price * item.quantity).toFixed(2))
      //     )
      //     .reduce((a, b) => a + b)
      //     .toFixed(2)
      // ),
      is_guest: true,
    },
  });

  return async (dispatch) => {
    dispatch({ type: CREATE_ORDER_PENDING });
    try {
      const result = await FETCH_POST({ query, variables });

      if (result.data.errors) {
        dispatch({
          type: CREATE_ORDER_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: CREATE_ORDER_FULFILLED,
          payload: result.data.data.createNewOrderForGuest,
        });
        dispatch(emptyCart());
        // TODO: ödeme onaylandı sayfasına yönlendir
        dispatch(
          push({
            pathname: "/siparis-basarili",
            state: {
              is_guest: true,
              order: result.data.data.createNewOrderForGuest,
            },
          })
        );
      }
    } catch (e) {
      dispatch({
        type: CREATE_ORDER_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

export const createNewOrderForCustomer = ({
  payment,
  address,
  setting,
  products,
  comment,
}) => {
  const cartTotalDiscountPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((product) =>
              parseFloat(
                calculatePrice(product, activeDiscount(product.categories))
              )
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const cartTotalPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((item) =>
              item.sale_price
                ? item.quantity * item.sale_price
                : item.quantity * item.price
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const discount = parseFloat(cartTotalPrice - cartTotalDiscountPrice).toFixed(
    2
  );

  const query = `mutation($input:createOrderForCustomerInput){createNewOrderForCustomer(input:$input){id,shipping_cost,discount,total_price,payment,c_number}}`;
  const variables = JSON.stringify({
    input: {
      status: "Onay Bekliyor",
      address,
      history: {
        status: "Onay Bekliyor",
        comment: "",
        notification: false,
      },
      products: products.map((item) => ({
        product: item.id,
        quantity: item.quantity,
        price: item.sale_price
          ? parseFloat((item.sale_price * item.quantity).toFixed(2))
          : parseFloat((item.price * item.quantity).toFixed(2)),
      })),
      comment,
      payment,
      shipping_cost: parseFloat(
        setting.free_shipping >= cartTotalPrice ? setting.shipping_cost : 0
      ),
      total_price:
        setting.free_shipping >= cartTotalDiscountPrice
          ? cartTotalDiscountPrice + setting.shipping_cost
          : cartTotalDiscountPrice,
      discount,
      // total_price: parseFloat(
      //   products
      //     .map((item) =>
      //       item.sale_price
      //         ? parseFloat((item.sale_price * item.quantity).toFixed(2))
      //         : parseFloat((item.price * item.quantity).toFixed(2))
      //     )
      //     .reduce((a, b) => a + b)
      //     .toFixed(2)
      // ),
      is_guest: false,
    },
  });

  return async (dispatch) => {
    dispatch({ type: CREATE_ORDER_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query, variables }, token);

        if (result.data.errors) {
          dispatch({
            type: CREATE_ORDER_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: CREATE_ORDER_FULFILLED,
            payload: result.data.data.createNewOrderForCustomer,
          });
          dispatch(emptyCart());
          // TODO: ödeme onaylandı sayfasına yönlendir
          dispatch(
            push({
              pathname: "/siparis-basarili",
              state: {
                is_guest: false,
                order: result.data.data.createNewOrderForCustomer,
              },
            })
          );
        }
      } catch (e) {
        dispatch({
          type: CREATE_ORDER_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));

      // TODO: login sayfasına yönlendir!
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/order.js